const SHARE_ID_PATTERN = /^[A-Za-z0-9_-]{1,128}$/;

export function getValidShareId(value) {
  const shareId = typeof value === "string" ? value.trim() : "";

  return SHARE_ID_PATTERN.test(shareId) ? shareId : "";
}
